import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://logarithmictech.com";
const DEFAULT_TITLE = "Logarithmic Technologies — Driving What's Next";
const DEFAULT_DESC =
  "The first practical speed reducer technology in 50 years — hollow-shaft, bearing-ball architecture engineered for defense, aerospace, marine, and energy propulsion partners.";
const DEFAULT_IMAGE = `${SITE}/brand/og-default.jpg`;

export default function SEO({
  title,
  description = DEFAULT_DESC,
  path = "",
  image = DEFAULT_IMAGE,
  type = "website",
}) {
  const fullTitle = title ? `${title} — Logarithmic Technologies` : DEFAULT_TITLE;
  const url = `${SITE}${path}`;
  const imageUrl = image.startsWith("/") ? `${SITE}${image}` : image;

  // React 19 hoists these meta tags natively (react-helmet-async's dedup is
  // disabled), so remove the static defaults from public/index.html once.
  // They stay in the raw HTML for non-JS crawlers (LinkedIn/Facebook bots).
  useEffect(() => {
    document.head.querySelectorAll("[data-rh]").forEach((el) => el.remove());
  }, []);

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph — LinkedIn, Facebook, iMessage, Slack */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Logarithmic Technologies" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Crawler hints */}
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="googlebot" content="index, follow" />
    </Helmet>
  );
}
